import React from 'react';
import PropTypes from 'prop-types';

import { componentInvariants } from 'bloko/common/helpers/customPropTypes';

import 'bloko/blocks/modal/modal.less';

/**
 * Надпись в заголовке модального окна
 */
export default function ModalTitle({ Element, ...modalTitleProps }) {
    return <Element {...modalTitleProps} className="bloko-modal-title" />;
}

ModalTitle.propTypes = {
    /** Контент */
    children: PropTypes.node,
    /** Тип элемента */
    Element: componentInvariants(['span', 'h1', 'h2', 'div']),
};

ModalTitle.defaultProps = {
    Element: 'span',
};
